import { render, staticRenderFns } from "./layoutAside.vue?vue&type=template&id=96e309de&scoped=true&"
import script from "./layoutAside.vue?vue&type=script&lang=js&"
export * from "./layoutAside.vue?vue&type=script&lang=js&"
import style0 from "./layoutAside.vue?vue&type=style&index=0&id=96e309de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e309de",
  null
  
)

export default component.exports